import moment from "moment";
import API from "../../../global/api";
import _ from "lodash";
import { socket } from "../../../socket";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const SET_MODULE_KEY = "SET_MODULE_KEY";
export const SET_HEADING_KEY = "SET_HEADING_KEY";


export const userLoginRequest = () => {
  return {
    type: "USER_LOGIN_REQUEST",
  };
};
export const userLoginSuccess = (data) => {
  return {
    type: "USER_LOGIN_SUCCESS",
    payload: data,
  };
};
export const userLoginError = (msg) => {
  return {
    type: "USER_LOGIN_ERROR",
    payload: msg
  };
};
export const UserLoginApi = (username, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(userLoginRequest())
    API.post(`/users/login`, username).then((res) => {
      let responseData = res.data;
      dispatch(userLoginSuccess(responseData));

      // window.localStorage.setItem("res", res.message);
      window.localStorage.setItem("token", responseData.token);
      window.localStorage.setItem("userId", responseData._id);
      window.localStorage.setItem("userName", responseData.userName);
      window.localStorage.setItem("role", responseData.role);
      // window.localStorage.setItem("isUser", true);
      // window.localStorage.setItem("isAdmin", false);
      // window.localStorage.setItem("isAuthenticated", true);
      window.localStorage.setItem("permissions", JSON.stringify(responseData.permission));
      window.location.replace('/home');

    }).catch((error) => {
      dispatch(userLoginError(_.isUndefined(error.response.data) ? error.message : error.response.data.message))
      handleDangerVisible(_.isUndefined(error.response.data) ? error.message : error.response.data.message)
    });
  };
};


export const requestGetME = () => {
  return {
    type: "REQUEST_GET_ME",
  };
};
export const successGetME = (data) => {
  return {
    type: "SUCCESS_GET_ME",
    payload: data,
  };
};
export const errorGetME = () => {
  return {
    type: "ERROR_GET_ME",
  };
}
export const MEApi = () => {
  return (dispatch) => {
    dispatch(requestGetME());
    API.get(`/users/me`).then((res) => {
      let getData = res.data;
      if (moment().format('YYYY-MM-DD') >= moment(getData.date).format('YYYY-MM-DD')) {
        window.localStorage.clear();
        socket.disconnect();
        window.location.replace('/login');
      }
      dispatch(successGetME(getData));
    }).catch((error) => {
      dispatch(errorGetME());
    })
  };
};


export const setModuleKey = (data) => {
  return {
    type: "SET_MODULE_KEY",
    payload: data,
  };
};
export const setHeading = (data) => {
  return {
    type: "SET_HEADING_KEY",
    payload: data,
  };
};
export const changeIsWrong = () => {
  return {
    type: "CHANGE_IS_WRONG",
  };
};